module.exports = __webpack_public_path__ + "img/certik.4612ca02.png";